import { QueryKey } from "react-query";
import { ID, Reference } from "~/Data";
import { Request } from "~/Request";
import { RevisionStatusType , RevisionStatus } from ".";



export namespace Query {
  export const tag = () => "Revision Status" as const;

  export type QueryIdParams = {
    readonly company: Reference.Reference;
  };

  export const id = (driverId: string, startDate: string): ID.ID => `${driverId}@${startDate}`;

  export const key = (driverId: string, startDate: string): QueryKey => [
    tag(),
    id(driverId, startDate),
  ];

  export const request = (driverId: string, startDate: string): Request.Fn<RevisionStatusType> => {
    const endpoint = `/time-tracking/users/${driverId}/revision-status?start_date=${startDate}`;
    return flow(
      Request.fromConfig({ endpoint }),
      Request.Expect.status(200),
      Request.Expect.json(RevisionStatus.Response.runtime()),
      Request.onSuccess(RevisionStatus.Response.decode)
    );
  };
}
